export default "__VITE_ASSET__BagbkmGe__"